import { render, staticRenderFns } from "./DetailProduct.vue?vue&type=template&id=12aaebe8&lang=html"
import script from "./DetailProduct.vue?vue&type=script&lang=js"
export * from "./DetailProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports